import React from 'react';
import PropTypes from 'prop-types';
import SelectExtrasForm from './select-extras-form';
import { SCENARIO_STANDARD_WITH_EXTRAS, ROUTE_TICKETS, ROUTE_PARKING, ROUTE_PARKING_STANDALONE } from './constants';
import SelectExtrasAside from './select-extras-aside';

export default class SelectExtrasPage extends React.Component {

    getNextRoute() {
        let nextRoute = ROUTE_TICKETS;

        if(this.props.isParkingStandaloneConfiguration){
            nextRoute = ROUTE_PARKING_STANDALONE;
        }

        if (this.props.currentScenario === SCENARIO_STANDARD_WITH_EXTRAS) {
            nextRoute = ROUTE_PARKING;
        }
        return nextRoute;
    }

    render() {

        return (
            <React.Fragment>
                <div className="ticket-builder__main">
                    <SelectExtrasForm
                        dictionary={this.props.dictionary}
                        basket={this.props.basket}
                        productGroupsList={this.props.productGroupsList}
                        currentProductType={this.props.currentProductType}
                        categoriesList={this.props.categoriesList}
                        onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                        onUpdateProductQuantity={this.props.onUpdateProductQuantity}
                        onClearSelection={this.props.onClearSelection}
                        currentScenario={this.props.currentScenario}
                    />
                </div>
                
                <div className="ticket-builder__aside">
                    <SelectExtrasAside
                        basket={this.props.basket}
                        nextRoute={this.getNextRoute()}
                        currentScenario={this.props.currentScenario}
                        productGroupsList={this.props.productGroupsList}
                        onToggleBasketMobile={this.props.onToggleBasketMobile}
                        onStartCheckout={this.props.onStartCheckout}
                        isNextStepAvailable={false}
                        isReadyToPay={true}
                        basketUrl={this.props.basketUrl}
                    />
                </div>
            </React.Fragment>
        );
    }
}

SelectExtrasPage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    basket: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    currentProductType: PropTypes.string.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onUpdateProductQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
    onToggleBasketMobile: PropTypes.func,
    onStartCheckout: PropTypes.func,
    currentScenario: PropTypes.string.isRequired,
    isParkingStandaloneConfiguration: PropTypes.bool
};
